export default {
    meta: {
        title: '找回密码',
        isShowHeader: false,
    },
};
